import secondaryComponents from "../../../../../components/secondaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";
import { SmsAutomatedTable } from "../../../../../components/secondaryComponents/SmsCampaign";
import { useAllSmsAutomatedCampaigns } from "./useAllSmsAutomatedCampaigns";
import { useNavigate } from "react-router-dom";
import primaryComponents from "../../../../../components/primaryComponents";
import { pathConstants } from "../../../../../routes/pathContants";
import { PlusIcon } from "../../../../../assets/svgIcons";

const AllSmsAutomatedCampaigns = () => {
  const { isLoadingSmsCampaigns, campaigns, metaDetails, gotoPage } =
    useAllSmsAutomatedCampaigns();
  const navigate = useNavigate();
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | SMS Campaigns - Automated"
      description="View all automated SMS campaigns"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total || 0} SMS campaigns</p>

            <primaryComponents.Button
              classNames={"btn btn--primary"}
              onClick={() =>
                navigate(pathConstants.MARKETING_SMS_CAMPAIGNS_CREATE)
              }
            >
              <PlusIcon className="mr-1" />
              Create Campaign
            </primaryComponents.Button>
          </div>

          <secondaryComponents.LoaderHelper
            isLoading={isLoadingSmsCampaigns}
            classNames={"mt-5"}
          >
            <SmsAutomatedTable
              automatedCampaigns={campaigns}
              metaDetails={metaDetails}
              gotoPage={gotoPage}
            />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default AllSmsAutomatedCampaigns;
